export const PERMISSIONS = {
	SpendSummaryRead: 'SpendSummary.Read',
	TransactionsWrite: 'Transactions.Write',
	TransactionsRead: 'Transactions.Read',
	OpportunitiesRead: 'Opportunities.Read',
	OpportunitiesWrite: 'Opportunities.Write',
	OpportunitiesVerify: 'Opportunities.Verify',
	RawDataWrite: 'RawData.Write',
	ExcelRead: 'Excel.Read',
	ExcelWrite: 'Excel.Write',
	TransactionsDeleteAll: 'Transactions.DeleteAll',
	SettingsWrite: 'Settings.Write',
	SettingsArchiveWrite: 'Settings.Archive.Write',
	SettingsClassificationWrite: 'Settings.Classification.Write',
	PlansRead: 'Plans.Read',
	PlansWrite: 'Plans.Write',
	ExecuteRead: 'Execute.Read',
	InsightsRead: 'Insights.Read',
	AnnotationsRead: 'Annotations.Read',
	AnnotationsWrite: 'Annotations.Write',
	BookmarksRead: 'Bookmarks.Read',
	BookmarksWrite: 'Bookmarks.Write',
	DataFactoryAccess: 'DataFactory.Access',
	CCORead: 'CCO.Read',
	CCOWrite: 'CCO.Write',
	UnpublishedDataApprove: 'UnpublishedData.Approve',
	UnpublishedDataRead: 'UnpublishedData.Read',
	UnpublishedDataWrite: 'UnpublishedData.Write',
	TaxonomyReleaseNotes: 'Taxonomy.ReleaseNotes',
	TaxonomyApplyNew: 'Taxonomy.ApplyNew',
	TaxonomyEdit: 'Taxonomy.Edit',
	SpendWheelRead: 'SpendWheel.Read',
	TrackingWrite: 'Tracking.Write',
	TaxonomyApply: 'Taxonomy.ApplyMapping',
	BenchMarkRead: 'BenchMark.Read',
	BenchMarkWrite: 'BenchMark.Write',
	AccessControlRead: 'AccessControl.Read',
	PortcoVisible: 'Portco.Visible',
	ApVendorDBRead: 'ApVendorDB.Read',
	ApVendorDBWrite: 'ApVendorDB.Write',
	SpendControllerRead: 'SpendController.Read',
	SpendControllerWrite: 'SpendController.Write',
	SpendControllerUpdate: 'SpendController.Update',
	SpendControllerUpload: 'SpendController.Upload',
	SpendControllerDelete: 'SpendController.Delete',
	SpendControllerUser: 'SpendController.User',
	AnalysisRead: 'Analysis.Read', // For Baseline tab
	InitiativesRead: 'Initiatives.Read',
	WavesRead: 'Waves.Read',
	BudgetRead: 'Budget.Read',
	CategoryRead: 'Category.Read', // For Manage Category tab
	BaselineRead: 'Baseline.Read',
	PreWorkShopRead: 'PreWorkShop.Read',
	WorkShopRead: 'WorkShop.Read',
	SavingsSignOffRead: 'SavingsSignOff.Read',
	FinanceReportRead: 'FinanceReport.Read',
	MicroTailRead: 'MicroTailLaunch.Read',
	AliasListRead: 'AliasList.Read',
	AliasListSendMail: 'AliasList.SendMail',
	AliasListWrite: 'AliasList.Write',
	SurveyBenchMarkRead: 'SurveyBenchMark.Read',
	SurveyFormRead: 'SurveyForm.Read',
	SurveyFormWrite: 'SurveyForm.Write',
	VendorDatabaseRead: 'VendorDatabase.Read',
	VendorDatabaseWrite: 'VendorDatabase.Write',
	SupplierDiversityDatabaseRead: 'SupplierDiversityDatabase.Read',
	SupplierDiversityDatabaseWrite: 'SupplierDiversityDatabase.Write',
	SkuRead: 'Sku.Read',
	SkuWrite: 'Sku.Write',
	TempLaborRead: 'TempLabor.Read',
	TempLaborWrite: 'TempLabor.Write',
	DataRedirect: 'DataRedirect',
	IntroductionRead: 'Introduction.Read',
};

export const SETTINGS_PERMISSIONS = [
	PERMISSIONS.SettingsWrite,
	PERMISSIONS.SettingsArchiveWrite,
	PERMISSIONS.SettingsClassificationWrite,
];

export const APPEND_PERMISSIONS = [
	PERMISSIONS.RawDataWrite,
	PERMISSIONS.TransactionsDeleteAll,
];

export const DOWNLOAD_PERMISSIONS = [
	PERMISSIONS.ExcelRead,
	PERMISSIONS.OpportunitiesRead,
];

export const UPLOAD_PERMISSIONS = [
	PERMISSIONS.ExcelWrite,
	PERMISSIONS.OpportunitiesVerify,
];

// For Data tab
export const DATA_PERMISSIONS = [
	...APPEND_PERMISSIONS,
	...DOWNLOAD_PERMISSIONS,
	...UPLOAD_PERMISSIONS,
	PERMISSIONS.SurveyFormRead,
	PERMISSIONS.SurveyFormWrite,
];

// For Spend Controller tab
export const SPEND_CONTROLLER_PERMISSIONS = [
	PERMISSIONS.SpendControllerRead,
	PERMISSIONS.SpendControllerWrite,
	PERMISSIONS.SpendControllerUpdate,
	PERMISSIONS.SpendControllerUpload,
];
export const BENCHMARK_PERMISSIONS = [
	PERMISSIONS.BenchMarkRead,
	PERMISSIONS.BenchMarkWrite,
];

//super user & elevated user
export const APVENDORDB_PERMISSIONS = [
	PERMISSIONS.ApVendorDBRead,
	PERMISSIONS.ApVendorDBWrite,
];
//grouped permissions
export const PUSH_TO_DB_PERMISSIONS = [
	PERMISSIONS.BenchMarkWrite,
	PERMISSIONS.ApVendorDBWrite,
];
export const APPEND_UPLOAD_PERMISSIONS = [
	...APPEND_PERMISSIONS,
	...UPLOAD_PERMISSIONS,
];

export const TAXONOMY_PERMISSIONS = [PERMISSIONS.TaxonomyApply];

// For Plan & Track tab
export const PLANANDTRACK_PERMISSIONS = [
	PERMISSIONS.InitiativesRead,
	PERMISSIONS.WavesRead,
	PERMISSIONS.BudgetRead,
];

// For Market Analysis tab
export const MARKET_ANALYSIS_PERMISSIONS = [
	PERMISSIONS.VendorDatabaseRead,
	PERMISSIONS.VendorDatabaseWrite,
	PERMISSIONS.SupplierDiversityDatabaseRead,
	PERMISSIONS.SupplierDiversityDatabaseWrite,
];

// For Speed to Market tab
export const SPEED_TO_MARKET_PERMISSIONS = [
	PERMISSIONS.SkuRead,
	PERMISSIONS.SkuWrite,
	PERMISSIONS.TempLaborRead,
	PERMISSIONS.TempLaborWrite,
];

export const TRANSACTIONS_PERMISSIONS = [
	PERMISSIONS.TransactionsRead,
	PERMISSIONS.TransactionsWrite,
	PERMISSIONS.TransactionsDeleteAll,
];
